<template>
  <div>
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5">Enter advisor code</h2>
            </v-col>
            <v-col cols="1">
              <v-icon class="close" color="black" @click.stop="closeDialog">{{
                icons.mdiClose
              }}</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text v-if="show" class="crud-card-text">
          <v-container class="pa-0 person-dialog-form-container">
            <v-row no-gutters>
              <v-col cols="12">
                <ValidationObserver ref="observer">
                  <v-form class="modal-form">
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <ValidationProvider
                          id="advisor_code"
                          v-slot="{ errors }"
                          name="advisor_code"
                          rules="required|adviserCode"
                        >
                          <v-text-field
                            v-model="advisorCode"
                            label="Advisor Code"
                            :error-messages="errors != '' ? errors + '.' : ''"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
              </v-col>
            </v-row>
          </v-container>
          <div class="crud-card-actions pb-0">
            <div class="button-container">
              <GradientButton
                :title="'Save'"
                :small="true"
                :callout="'right'"
                @gradientButtonClicked="save"
                :loading="false"
              />
              <GradientButton
                :title="`Ask me later`"
                :small="true"
                :fill="false"
                :callout="'right'"
                @gradientButtonClicked="closeDialog"
              />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { UPDATE_USER_MUTATION } from '../../constants/graphql/users';

  export default {
    name: 'AdvisorCodeDialog',
    components: {},
    props: {
      value: { type: Boolean },
    },
    data() {
      return {
        advisorCode: null,
      };
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    methods: {
      closeDialog() {
        this.show = false;
        this.$emit('advisorCodeModalClosed');
      },
      async save() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        const userInputDetails = {
          advisorCode: this.advisorCode,
        };
        const id = this.userId;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_MUTATION,
            variables: {
              id,
              userInputDetails,
            },
          })
          .then(_response => {
            this.closeDialog();
          })
          .catch(error => {
            throw error;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    gap: 12px;
    margin-bottom: 0px;
  }
</style>
